import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Product from './pages/Product';
import Payment from './pages/Payment';
import Confirmation from './pages/Confirmation';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Rules from './pages/Rules';
import Cgu from './pages/Cgu';
import MentionsLegales from './pages/MentionsLegales';
import NotFound from './pages/NotFound';

const App = () => {
  return (
    <AuthProvider>
      <HelmetProvider>
        <Helmet>
          <script async src="https://www.googletagmanager.com/gtag/js?id=G-JTJE4MGWKE"></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-JTJE4MGWKE');
            `}
          </script>
        </Helmet>

        <Router>
          <Navbar />
          <div className="App">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/product/:id" element={<Product />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/confirmation" element={<Confirmation />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/cgu" element={<Cgu />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </Router>
      </HelmetProvider>
    </AuthProvider>
  );
};

export default App;
